import { Link } from "react-router-dom";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const serviceLinks = [
    { label: "Giảm cân & Giảm mỡ", path: "/service/giam-can-giam-mo" },
    { label: "Cải thiện vóc dáng", path: "/service/cai-thien-voc-dang" },
    { label: "Giảm đau xương khớp", path: "/service/giam-dau-nhuc-xuong-khop" },
    { label: "Thư giãn cơ thể", path: "/service/thu-gian-dieu-tri-moi-co" },
  ];

  const quickLinks = [
    { label: "Trang chủ", path: "/" },
    { label: "Giới thiệu", path: "/about" },
    { label: "Dịch vụ", path: "/services" },
    { label: "Đặt lịch", path: "/booking" },
  ];

  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-leaf-line text-lg" />
              </div>
              <span className="font-display text-xl font-bold text-background-50">
                Xanh Wellness
              </span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed mb-4">
              Chăm sóc sức khỏe từ tâm, khỏe đẹp tự nhiên. Trải nghiệm công nghệ chăm sóc sức khỏe cao cấp với cabin spa thông minh.
            </p>
            <div className="flex items-center gap-3">
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-800 hover:bg-primary-700 text-background-200 hover:text-background-50 transition-colors"
                aria-label="Facebook"
              >
                <i className="ri-facebook-fill" />
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-800 hover:bg-primary-700 text-background-200 hover:text-background-50 transition-colors"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line" />
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-800 hover:bg-primary-700 text-background-200 hover:text-background-50 transition-colors"
                aria-label="TikTok"
              >
                <i className="ri-tiktok-fill" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-label text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">
              Liên kết nhanh
            </h4>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-label text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">
              Dịch vụ
            </h4>
            <ul className="space-y-2.5">
              {serviceLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-background-300 hover:text-background-50 transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-label text-sm font-semibold text-background-50 uppercase tracking-wider mb-4">
              Liên hệ
            </h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 text-background-400">
                  <i className="ri-map-pin-line text-sm" />
                </div>
                <span className="text-sm text-background-300 leading-relaxed">
                  HH3C Linh Đàm, Hoàng Liệt, Hà Nội
                </span>
              </li>
              <li className="flex items-start gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 text-background-400">
                  <i className="ri-phone-line text-sm" />
                </div>
                <a
                  href="tel:0978665639"
                  className="text-sm text-background-300 hover:text-background-50 transition-colors"
                >
                  0978 665 639
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 text-background-400">
                  <i className="ri-mail-line text-sm" />
                </div>
                <a
                  href="mailto:admin@chinchin.vn"
                  className="text-sm text-background-300 hover:text-background-50 transition-colors"
                >
                  admin@chinchin.vn
                </a>
              </li>
              <li className="flex items-start gap-2.5">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 text-background-400">
                  <i className="ri-time-line text-sm" />
                </div>
                <span className="text-sm text-background-300 leading-relaxed">
                  T2 - CN: 08:00 - 20:00
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Copyright bar */}
      <div className="border-t border-primary-800">
        <div className="w-full px-4 md:px-8 lg:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-background-400 text-center sm:text-left">
            &copy; {currentYear} Xanh Wellness. Tất cả quyền được bảo lưu.
          </p>
          <div className="flex items-center gap-4">
            <Link
              to="#"
              className="text-xs text-background-400 hover:text-background-200 transition-colors whitespace-nowrap"
            >
              Chính sách bảo mật
            </Link>
            <Link
              to="#"
              className="text-xs text-background-400 hover:text-background-200 transition-colors whitespace-nowrap"
            >
              Điều khoản sử dụng
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}